import { SET_EXCLUDE_PERSONAL_DETAILS } from "redux/types";

const setExcludePersonalDetails = (payload) => {
    return { type: SET_EXCLUDE_PERSONAL_DETAILS, payload };
};

export { setExcludePersonalDetails };
